module.exports = __webpack_public_path__ + "static/media/13_l_derevo_11.56_36.85.99f8032c.png";